/**
 * Diagonal line drawn across a sold-out option (variant card, image swatch).
 * Stretches to the positioned parent, so the parent must be `position: relative`.
 */
const OutOfStockSlash: React.FC = () => (
  <svg
    viewBox="0 0 100 100"
    preserveAspectRatio="none"
    aria-hidden="true"
    focusable="false"
    className="out-of-stock-slash"
  >
    <line
      x1="100"
      y1="0"
      x2="0"
      y2="100"
      vectorEffect="non-scaling-stroke"
      strokeWidth="1"
      strokeLinecap="round"
      className="stroke-gray4"
    />
  </svg>
);

export default OutOfStockSlash;
